import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconSparkle",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 1a.5.5 0 0 1 .5.5V2h.5a.5.5 0 0 1 0 1h-.5v.5a.5.5 0 1 1-1 0V3H8a.5.5 0 0 1 0-1h.5v-.5A.5.5 0 0 1 9 1ZM5 2a.5.5 0 0 1 .455.293L6.471 4.53l2.236 1.016a.5.5 0 0 1 0 .91L6.47 7.471 5.455 9.707a.5.5 0 0 1-.91 0L3.529 7.47 1.293 6.455a.5.5 0 0 1 0-.91L3.53 4.529l1.016-2.236A.5.5 0 0 1 5 2Zm0 1.708-.639 1.405a.5.5 0 0 1-.248.248L2.708 6l1.405.639a.5.5 0 0 1 .248.248L5 8.292l.639-1.405a.5.5 0 0 1 .248-.248L7.292 6l-1.405-.639a.5.5 0 0 1-.248-.248L5 3.708ZM9.5 8a.5.5 0 0 1 .5.5V9h.5a.5.5 0 0 1 0 1H10v.5a.5.5 0 0 1-1 0V10h-.5a.5.5 0 0 1 0-1H9v-.5a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function h(e, u, r, p, f, a) {
  return l(), i("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--sparkle"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Sparkle",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const b = /* @__PURE__ */ o(s, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=sparkle.js.map
